<template>
  <header class="event-header" v-if="event && event.exhibition">
    <div class="container">
      <div class="event-header__top">
        <img
          :src="eventLogo"
          :alt="eventName"
          class="event-header__top-image"
        />

        <div class="event-header__top-content">
          <p class="event-header__top-content-date">
            {{ startDate }} – {{ endDate }}
          </p>
          <h1 class="event-header__top-content-title">{{ eventName }}</h1>

          <template>
            <div class="event-header__сompany-name">
              {{ companyName }}
            </div>

            <div
              class="event-header__buttons-wrapper"
              v-if="companies.length > 1"
            >
              <LinkIcon
                icon="checked-list"
                @click="$modal.show('event-modal-change-company')"
                class="event-header__change-company-btn"
              >
                {{ $t("event.changeCompany.btnText") }}
              </LinkIcon>

              <button
                class="event-header__change-company-btn event-header__change-company-btn--mobile"
                @click="$modal.show('event-modal-change-company')"
              >
                {{ $t("event.changeCompany.btnText") }}
              </button>
            </div>
          </template>
          <!--Сменить компанию end-->
        </div>
        <EventStand />
      </div>

      <div
        class="event-header__navigation-mobile"
        @click="toggle"
        v-if="event.status === 'confirmed'"
        :class="{ mobile_open: !isOpenList }"
      >
        <a href="#" class="event-header__navigation-mobile-link">
          {{ $t("event.header.nav.info") }}
        </a>
        <icon name="arrow-down_grey" width="11px" height="7px" />
      </div>

      <ul
        class="event-header__navigation"
        v-if="event.status === 'confirmed'"
        :class="{ open_list: isOpenList }"
      >
        <li class="event-header__navigation-item">
          <a
            href="#"
            class="event-header__navigation-item-link"
            @click.prevent="scrollTo('#event-company-profile')"
          >
            {{ $t("event.header.nav.companyProfile") }}
            <icon
              name="warning"
              width="16px"
              height="16px"
              v-if="!hasCompleteCompany"
            />
          </a>
        </li>

        <li class="event-header__navigation-item">
          <a
            href="#"
            class="event-header__navigation-item-link"
            @click.prevent="scrollTo('#event-users')"
          >
            {{ $t("event.header.nav.users") }}
          </a>
        </li>

        <li class="event-header__navigation-item" v-if="isShowSubs">
          <a
            href="#"
            class="event-header__navigation-item-link"
            @click.prevent="scrollTo('#event-subexponents')"
          >
            {{ $t("event.header.nav.subexponents") }}
          </a>
        </li>

        <li class="event-header__navigation-item" v-if="isServiceShown">
          <a
            href="#"
            class="event-header__navigation-item-link"
            @click.prevent="scrollTo('#event-services-order')"
          >
            {{ $t("event.header.nav.servicesOrder") }}
          </a>
        </li>

        <li class="event-header__navigation-item" v-if="isShowCatalog">
          <a
            href="#"
            class="event-header__navigation-item-link"
            @click.prevent="scrollTo('#event-catalog-placement')"
          >
            {{ $t("event.header.nav.order") }}
          </a>
        </li>

        <li class="event-header__navigation-item" v-if="isShowPasses">
          <a
            href="#"
            class="event-header__navigation-item-link"
            @click.prevent="scrollTo('#event-passes')"
          >
            {{ $t("event.header.nav.pass") }}

            <icon
              name="warning"
              width="16px"
              height="16px"
              v-if="showPassWarning"
            />
          </a>
        </li>

        <li class="event-header__navigation-item" v-if="isShowDocuments">
          <a
            href="#"
            class="event-header__navigation-item-link"
            @click.prevent="scrollTo('#event-documents')"
          >
            {{ $t("event.documents.title") }}
          </a>
        </li>
      </ul>
    </div>
    <div
      v-if="event.exhibition.notifications?.length"
      class="event-notifications"
    >
      <div class="container event-notifications__content">
        <Notification
          class="event-notifications__item"
          v-for="(item, i) in event.exhibition.notifications"
          :key="i"
          icon="warning-border--no-color"
        >
          <span
            v-html="locale === 'en' ? item.message_eng : item.message_rus"
          ></span>
        </Notification>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import image from "/public/static/images/event-no-company-image.svg";
import passHelper from "@/helpers/pass";
import { i18n } from "@v2/shared/config";
import { LinkIcon, Notification } from "@v2/shared/ui/components";
import EventStand from "@/components/Custom/EventStand.vue";

export default {
  name: "EventHeader",
  components: {
    EventStand,
    Notification,
    LinkIcon
  },

  data() {
    return {
      isOpenList: true,
      noPhoto: image
    };
  },

  computed: {
    ...mapState("event", ["event", "companies"]),

    ...mapGetters("event", [
      "isEventSubexponent",
      "isEventSubexponentViewedByOrganizer",
      "isEventOrganizer",
      "isEventMontage",
      "isSpecialProject",
      "isPartTime",
      "isEventSelf",
      "isOrganizerAndMedia",
      "exhibition",
      "isServiceShown",
      "participantType",
      "hasCompleteCompany",
      "passDeadline",
      "companyName",
      "isUserRoleInstaller"
    ]),

    locale() {
      return i18n.locale;
    },
    startDate() {
      return moment(this.event.exhibition.started_at)
        .locale(i18n.locale)
        .format("DD MMMM YYYY");
    },

    endDate() {
      return moment(this.event.exhibition.ended_at)
        .locale(i18n.locale)
        .format("DD MMMM YYYY");
    },

    eventName() {
      if (!(this.event && this.event.exhibition)) {
        return "";
      }

      return i18n.locale === "en"
        ? this.event.exhibition.name_eng
        : this.event.exhibition.name_rus;
    },
    eventLogo() {
      return this.event.exhibition.image?.thumbnail_path
        ? `${process.env.VUE_APP_URL}storage/${this.event.exhibition.image.thumbnail_path}`
        : this.noPhoto;
    },
    showPassWarning() {
      return passHelper.showWarning(this.passDeadline);
    },
    isShowPasses() {
      return !this.isPartTime && !this.isUserRoleInstaller;
    },
    isShowCatalog() {
      return (
        !this.isOrganizerAndMedia &&
        !this.isSpecialProject &&
        !this.isUserRoleInstaller
      );
    },
    isShowSubs() {
      return this.isEventOrganizer && !this.isUserRoleInstaller;
    },
    isShowDocuments() {
      return (
        (this.isEventSelf || this.isEventOrganizer) && !this.isUserRoleInstaller
      );
    }
  },

  methods: {
    scrollTo(selector) {
      const element = document.querySelector(selector);

      this.$scrollTo(selector, 500, {
        offset: -60,

        onDone() {
          element.classList.add("scroll-hightlight");

          setTimeout(function() {
            element.classList.remove("scroll-hightlight");
          }, 1000);
        }
      });
    },
    toggle() {
      this.isOpenList = !this.isOpenList;
    }
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.event-header {
  background: #fff;
  border-bottom: 1px solid var(--gray-darker);

  @include respond-down(md) {
    padding: 15px 0 0 0;
  }

  &__top {
    display: flex;

    margin-top: 40px;
    margin-left: 8px;
    margin-bottom: 24px;

    min-height: 80px;

    @include respond-down(md) {
      margin: 0;

      flex-wrap: wrap;

      min-height: 0;
    }

    &-image {
      width: 64px;
      align-self: flex-start;
      flex-shrink: 0;

      margin-top: 9px;
      margin-right: 25px;

      @include respond-down(md) {
        width: 48px;
        margin-right: 16px;
        margin-top: 4px;
      }
    }

    &-content {
      margin-right: auto;
      padding-right: 25px;

      @include respond-down(md) {
        padding-right: 15px;
        margin-bottom: 28px;
        flex: 1 0;
      }

      &-date {
        margin-top: 10px;
        margin-bottom: 3px;

        font-size: 13px;
        line-height: 1.54;
        color: #000000;

        @include respond-down(md) {
          font-size: 12px;

          margin: 0 0 4px 0;
        }
      }

      &-title {
        font-size: 34px;
        font-weight: bold;
        line-height: 1.18;
        color: #000000;
        margin: 0;

        @include respond-down(lg) {
          font-size: 30px;
        }
        @include respond-down(md) {
          font-size: 18px;
        }
      }

      &-reader {
        @include button-clean();

        font-size: 14px;
        font-weight: 500;

        display: flex;
        align-items: center;

        margin-top: 10px;

        .svg-icon {
          width: 16px;
          height: 16px;

          flex-shrink: 0;

          margin-left: 5px;
        }
      }
    }
  }

  &__сompany-name {
    margin-top: 20px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;

    @include respond-down(md) {
      margin-top: 18px;
      line-height: 18px;
    }
  }

  &__navigation {
    list-style: none;
    padding: 0;
    margin: 0 0 30px -1px;

    display: flex;
    flex-wrap: wrap;

    @include respond-down(lg) {
      // display: none;
    }

    @include respond-down(md) {
      flex-direction: column;
      width: 100%;
      background-color: #fff;
      margin: 0 -16px;
    }

    &-item {
      margin-top: 16px;
      margin-right: 16px;

      &:last-child {
        margin-right: 0;
      }

      @include respond-down(md) {
        margin-top: 0;

        &:last-child {
          margin-right: 16px;
        }
      }
      &-link {
        border-radius: 2px;
        background-color: #f1f1f1;

        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
        color: #55575a;

        padding: 8.5px 12px;

        text-decoration: none;

        border: 1px solid transparent;

        display: block;

        position: relative;

        transition: all 0.3s;

        @include respond-down(md) {
          background-color: #fff;
          padding: 12px 16px;
        }

        .svg-icon--warning {
          position: absolute;
          right: -6px;
          top: -6px;
        }

        &:hover {
          border-color: #0070d2;
          background: #fff;
        }

        &_main {
          color: #005197;
        }
      }
    }

    &-mobile {
      display: none;
      @include respond-down(md) {
        font-size: 11px;
        font-weight: 500;
        line-height: 1.45;

        display: flex;
        justify-content: space-between;
        align-items: center;

        padding: 16px 16px;
        margin: 16px -16px 0 -16px;
        border-top: 1px solid #f1f1f1;

        svg {
          transition: all 0.2s;
          fill: #767676;
        }

        &-link {
          text-decoration: none;
          color: #505050;
        }

        &_open {
          padding-bottom: 12px;
          svg {
            transform: rotate(180deg);
            color: #005197;
          }
          .event-header__navigation-mobile-link {
            color: #005197;
          }
        }
      }
    }
  }

  &__change-company-btn {
    font-weight: 500;

    @include respond-down(lg) {
      display: none;
    }

    &--mobile {
      display: none;
      @include underline-button;

      @include respond-down(lg) {
        display: block;
      }
    }
  }

  &__buttons-wrapper {
    margin-top: 7px;
    margin-bottom: 14px;

    @include respond-down(lg) {
      margin-top: 9px;
      margin-bottom: 5px;
    }

    @include respond-down(md) {
      margin-top: 14px;
      margin-bottom: 3px;
    }
  }
}
@include respond-down(md) {
  .mobile_open {
    padding-bottom: 12px;

    .event-header__navigation-mobile-link {
      color: #005197;
    }
    svg {
      transform: rotate(180deg);
      color: #005197;
    }
  }
  .open_list {
    display: none;
  }
}
.event-notifications {
  &__content {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: flex-start;
    align-items: flex-start;
    margin-bottom: 20px;
  }
  &__item {
    display: flex;
    margin-bottom: 10px;
    width: 100%;
  }
}
</style>
